import React from 'react';

export const LibraryIcon = ({ size = 24, className = '', fill = 'white' }) => {
    return (
        <svg
            fill={fill}
            height={size}
            width={size}
            ariaHidden='true'
            className={className}
            viewBox='0 0 24 24'
        >
            <path d='M14.5 2.134a1 1 0 011 0l6 3.464a1 1 0 01.5.866V21a1 1 0 01-1 1h-6a1 1 0 01-1-1V3a1 1 0 01.5-.866zM16 4.732V20h4V7.041l-4-2.309zM3 22a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1zm6 0a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1z'></path>
        </svg>
    );
};

export const ActiveLibraryIcon = ({ size = 24, className = '', fill = 'white' }) => {
    return (
        <svg
            fill={fill}
            height={size}
            width={size}
            ariaHidden='true'
            className={className}
            viewBox='0 0 24 24'
        >
            <path d='M3 22a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1zM15.5 2.134A1 1 0 0014 3v18a1 1 0 001 1h6a1 1 0 001-1V6.464a1 1 0 00-.5-.866l-6-3.464zM9 2a1 1 0 00-1 1v18a1 1 0 102 0V3a1 1 0 00-1-1z'></path>
        </svg>
    );
};
